import * as types from './shipmentActionTypes';

export const getShipmentRequest = (payload) => 
({ type: types.GET_SHIPMENT_REQUEST, payload });
export const getShipmentSuccess = (payload) => 
({ type: types.GET_SHIPMENT_SUCCESS, payload });
export const getShipmentError = (payload) => 
({ type: types.GET_SHIPMENT_ERROR, payload });

export const addShipmentRequest = (payload) => 
({ type: types.ADD_SHIPMENT_REQUEST, payload });
export const addShipmentSuccess = (payload) => 
({ type: types.ADD_SHIPMENT_SUCCESS, payload });
export const addShipmentError = (payload) => 
({ type: types.ADD_SHIPMENT_ERROR, payload });

export const updateShipmentRequest = (payload) => 
({ type: types.UPDATE_SHIPMENT_REQUEST, payload });
export const updateShipmentSuccess = (payload) => 
({ type: types.UPDATE_SHIPMENT_SUCCESS, payload });
export const updateShipmentError = (payload) => 
({ type: types.UPDATE_SHIPMENT_ERROR, payload });

export const deleteShipmentRequest = (payload) => 
({ type: types.DELETE_SHIPMENT_REQUEST, payload });
export const deleteShipmentSuccess = (payload) => 
({ type: types.DELETE_SHIPMENT_SUCCESS, payload });
export const deleteShipmentError = (payload) => 
({ type: types.DELETE_SHIPMENT_ERROR, payload }); 